import React, { useState } from 'react';
import { useGame } from '../context/GameContext';
import GameCard from '../components/GameCard';

export default function Shrine() {
  const { pendingShrine, chooseShrineOption, skipShrine } = useGame();
  const [selectingCard, setSelectingCard] = useState(null); // shrine idx we're picking a card for
  if (!pendingShrine) return null;
  const shrine = pendingShrine.shrine;
  const { run } = pendingShrine;

  if (selectingCard !== null) {
    return (
      <div className="min-h-screen w-full px-6 py-6" data-testid="shrine-card-select">
        <div className="flex items-center justify-between">
          <button className="brutal-btn text-sm" onClick={() => setSelectingCard(null)} data-testid="shrine-cancel">CANCEL</button>
          <h1 className="font-display text-3xl font-black uppercase text-[color:var(--pink)]">SACRIFICE A CARD</h1>
          <div className="w-24"/>
        </div>
        <div className="mt-8 flex flex-wrap gap-4 justify-center">
          {run.player.deck.map((cid, i) => (
            <div key={i} onClick={() => chooseShrineOption(i)} className="cursor-pointer hover:scale-105 transition-transform">
              <GameCard cardId={cid} testid={`shrine-sacrifice-${i}`} />
            </div>
          ))}
        </div>
      </div>
    );
  }

  const needsCard = shrine.cost === 'card';
  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center px-6" data-testid="shrine-screen">
      <div className="text-xs uppercase tracking-[0.4em] text-[color:var(--text-dim)]">✧ SHRINE ✧</div>
      <div className="text-8xl mt-4">{shrine.art}</div>
      <h1 className="font-display text-5xl font-black uppercase text-[color:var(--pink)] mt-4 text-center">{shrine.name}</h1>
      <div className="mt-4 text-center text-[color:var(--text)] max-w-xl">
        <div><span className="text-[color:var(--red)]">COST:</span> {shrine.cost === 'card' ? 'Sacrifice one card from your deck.' : 'Lose 10 HP.'}</div>
        <div className="mt-2"><span className="text-[color:var(--neon)]">GAIN:</span> {shrine.gain}</div>
      </div>
      <div className="mt-10 flex gap-4">
        <button className="brutal-btn-pink brutal-btn text-lg" onClick={() => needsCard ? setSelectingCard(0) : chooseShrineOption(null)} data-testid="shrine-offer">
          MAKE OFFERING
        </button>
        <button className="brutal-btn text-lg" onClick={skipShrine} data-testid="shrine-skip">WALK PAST</button>
      </div>
    </div>
  );
}
